import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";

import { Footer } from "../../components/Footer/Footer";
import { useSelections } from "../../context/Selections";

const OBJECTS_IDS = {
  ATING: "tayay",
  DESEM: "PCBJ",
  ACOMP: "JcLvDj",
  QUARTER: "hDJWWa",
};

function QualifiedFormatoDesktop({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setSelectedValue] = useState("Acompanhamento Mensal");
  const [quater, setQuater] = useState("");

  const getQuater = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setQuater(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  const handleChange = (event) => {
    app.field("DESC.").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "DESC.")
        : null;

      setSelectedValue(distributors?.qSelected);
    }
  }, [selections, app]);

  useEffect(() => {
    if (app) {
      getQuater(OBJECTS_IDS.QUARTER);
    }
  }, [selections, app, getQuater]);

  return (
    <div className="app qualifiedCoverage">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container className="container-atingimento">
            <Grid>
              <Card className="container-card-only-title">
                <h1 className="title"> % Cobertura Formatos</h1>
                <p className="subtitle">Período analisado: {quater}</p>
              </Card>
            </Grid>

            <Card
              app={app}
              header={{
                hardTitle: "Atingimento por PDV",
              }}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.ATING}
              style={{ margin: "2.9px 0 16px 0" }}
              expandable
            >
              <div className="container-legends">
                <p className="container-item item-meta">
                  <span className="item-color color-meta" />
                  <span className="item-text">Meta</span>
                </p>

                <p className="container-item item-realizado">
                  <span className="item-color color-realizado" />
                  <span className="item-text">Realizado</span>
                </p>
              </div>
              <NativeObject
                app={app}
                key={OBJECTS_IDS.ATING}
                reference={{ id: OBJECTS_IDS.ATING }}
                style={{
                  width: "100%",
                  height: "370px",
                }}
              />
            </Card>
          </Grid>

          <Grid className="container-desempenho" sx={{ marginBottom: "16px" }}>
            <Card
              app={app}
              header={{
                hardTitle: "Desempenho por PDV",
              }}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.DESEM}
              expandable
            >
              <NativeObject
                app={app}
                key={OBJECTS_IDS.DESEM}
                reference={{ id: OBJECTS_IDS.DESEM }}
                style={{
                  width: "100%",
                  height: "370px",
                }}
              />
            </Card>
          </Grid>

          <Grid
            className="container-acompanhamento"
            sx={{ marginBottom: "16px" }}
          >
            <Card
              app={app}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.ACOMP}
              style={{ margin: "16px 0" }}
              expandable
            >
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Acompanhamento Mensal"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={handleChange}
                  sx={{ margin: "0px 0 25px 0" }}
                >
                  <FormControlLabel
                    value="Mapa da Mina"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#173354",
                          "&.Mui-checked": {
                            color: "#173354",
                          },
                        }}
                      />
                    }
                    label="Mapa da Mina"
                  />
                  <FormControlLabel
                    value="Acompanhamento Mensal"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#173354",
                          "&.Mui-checked": {
                            color: "#173354",
                          },
                        }}
                      />
                    }
                    label="Acompanhamento Mensal"
                  />
                </RadioGroup>
              </FormControl>

              <NativeObject
                app={app}
                key="ZZpsX"
                reference={{ id: OBJECTS_IDS.ACOMP }}
                style={{
                  width: "100%",
                  height: "300px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

QualifiedFormatoDesktop.defaultProps = {
  app: null,
  config: {},
};

QualifiedFormatoDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default QualifiedFormatoDesktop;
